import { render, staticRenderFns } from "./Manufacturers.html?vue&type=template&id=1e845392&external"
import script from "./Manufacturers.js?vue&type=script&lang=js&external"
export * from "./Manufacturers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports